import { useAppForm } from "@features/forms/config";
import { FirebaseError } from "firebase/app";
import { z } from "zod";
import usePasswordReset from "./usePasswordReset";

const input = z.object({
  email: z.email("errorEmailInvalid"),
});

async function mapPasswordResetError(error: unknown) {
  if (error instanceof FirebaseError) {
    const { AuthErrorCodes } = await import("firebase/auth");
    if (error.code === AuthErrorCodes.USER_DELETED) {
      return undefined;
    }
    if (error.code === AuthErrorCodes.TOO_MANY_ATTEMPTS_TRY_LATER) {
      return "internalError";
    }
  }
  return "internalError";
}

export default function usePasswordResetForm() {
  const resetPassword = usePasswordReset();

  return useAppForm({
    defaultValues: {
      email: "",
    },
    validators: {
      onChange: ({ value }) => {
        const validation = input.safeParse(value);
        if (!validation.success) {
          return {
            fields: Object.fromEntries(
              validation.error.issues.map((issue) => [
                issue.path.join("."),
                issue.message,
              ]),
            ),
          };
        }
        return undefined;
      },
      onSubmitAsync: async ({ value }) => {
        try {
          await resetPassword(value.email);
          return undefined;
        } catch (error) {
          return mapPasswordResetError(error);
        }
      },
    },
  });
}
